<template>
  <div id="app">
    <v-app id="inspire" v-if="!isLogInPage()">
      <v-app-bar app clipped-right color="#000" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Management System</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" app width="300">
        <div class="pb-10 pt-8 bg-lightblue mb-6" style="">
          <v-img class="mx-auto" src="@/assets/images/aafmc-logo1.png" width="180"/>
        </div>

        <v-list-item two-line dense class="mb-2">
          <v-avatar
            color="primary"
            size="48"
            class="mr-4"
          >
            <span class="white--text text-h6">{{getMyInitial}}</span>
          </v-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ capitalise(getFullname) }}</v-list-item-title>
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list dense>
          <v-list-item-group>
          <template v-for="section in getMenu()">
            <v-list-item
              v-if="section.type=='link'"
              v-bind:key="section.name"
              :to="{ name: section.route }"
            >
            <!-- :class="section.route === $route.path ? 'highlighted' : 'nothighlighted'" -->
              <v-list-item-icon>
                <v-icon>{{ section.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title >{{ section.name }}</v-list-item-title>
            </v-list-item>
            <v-list-group
              v-bind:key="section.name"
              v-if="section.type=='toggle'"
              :value="section.route === $route.path ? true : false"
              :prepend-icon="section.icon"
              no-action

            >
              <template v-slot:activator>
                <v-list-item-title>{{ section.name }}</v-list-item-title>
              </template>


              <v-list-item
                v-for="child in section.children"
                v-bind:key="child.name"
                :to="{ name: child.route }"
              >
                <v-list-item-title v-text="child.name"></v-list-item-title>

                <!-- <v-list-item-icon>
                  <v-icon v-text="icon"></v-icon>
                </v-list-item-icon> -->
              </v-list-item>

            </v-list-group>

          </template>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-main class="grey lighten-4">
        <a v-if="$getConstRole('ROLE_CLIENT') === getCurrentUser.role" class="text-decoration-none" href="https://aaf-express.com" target="_blank">
          <v-img class="" src="@/assets/images/aaf-express.png"/>
        </a>        
        <div class="px-12 py-9">          
          <router-view/>
        </div>
      </v-main>

      <v-footer :inset="true" app class="pl-12">
        <span>&copy; 2023 All Rights Reserved.</span>
      </v-footer>
    </v-app>

    <v-app id="inspire" v-if="isLogInPage()">      
      <router-view/>
    </v-app>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  name: 'AppTemplate',

  data: () => ({
    drawer: null,
    sections:[]
  }),

  computed: {
    ...mapGetters(['getCurrentUser', 'getMyInitial', 'getFullname', 'capitalise']),
  },
  mounted () {
    this.$store.commit('setApiUrl', { url: '' })
  },
  methods: {
    isLogInPage(){
      if(this.$route.name == 'login' ||
        this.$route.name == 'forgot-password' ||
        this.$route.name == 'confirm-registration' ||
        this.$route.name == 'confirm-token' ||
        this.$route.name == 'resend-confirmation-token' ||
        this.$route.name == 'confirm-reset-password-token' ||
        this.$route.name == 'create-new-account'){
          return true
      }
      return false
    },
    getMenu(){
      let sections = []
      if(this.$getConstRole('ROLE_CLIENT') == this.getCurrentUser.role){
        sections = [
          { id: 1, name: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: 'dashboard', type: 'link', active: false },
          // { id: 2, name: 'Tracking Orders', icon: 'mdi-truck-check-outline', route: 'tracking-orders', type: 'link', active: false },
          { id: 2, name: 'Bookings', icon: 'mdi-file-document-multiple-outline', route: 'bookings', type: 'link', active: false },
          { id: 3, name: 'Dispatch', icon: 'mdi-truck-delivery-outline', type: 'toggle', active: false,
            children: [
              { name: 'To Receive', route: 'delivery-to-receive' },
              { name: 'Received', route: 'delivery-received' }
            ]
          },
          { id: 4, name: 'Rewards Club Royale', icon: 'mdi-medal-outline', route: 'client-rewards', type: 'link', active: false },
          { id: 5, name: 'Invoices', icon: 'mdi-receipt-text-outline', route: 'invoices', type: 'link', active: false },
          { id: 6, name: 'Settings', icon: 'mdi-cog-outline', route: 'settings', type: 'link', active: false },
          { id: 7, name: 'Logout', icon: 'mdi-logout', route: 'logout', type: 'link', active: false }
        ]
      }else if(this.$getConstRole('ROLE_AGENT') == this.getCurrentUser.role){
        sections = [
          { id: 1, name: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: 'dashboard', type: 'link', active: false },
          // { id: 2, name: 'Tracking Orders', icon: 'mdi-truck-check-outline', route: 'tracking-orders', type: 'link', active: false },
          { id: 2, name: 'Clients', icon: 'mdi-account-group-outline', route: 'clients', type: 'link', active: false },
          { id: 3, name: 'Bookings', icon: 'mdi-file-document-multiple-outline', route: 'bookings', type: 'link', active: false },
          { id: 4, name: 'Invoices', icon: 'mdi-receipt-text-outline', route: 'invoices', type: 'link', active: false },
          { id: 5, name: 'Rewards Club Royale', icon: 'mdi-medal-outline', route: 'rewards-clients', type: 'link', active: false },
          // { id: 5, name: 'Reports', icon: 'mdi-text-box-outline', route: 'reports', type: 'link', active: false },
          { id: 6, name: 'Settings', icon: 'mdi-cog-outline', route: 'settings', type: 'link', active: false },
          { id: 7, name: 'Logout', icon: 'mdi-logout', route: 'logout', type: 'link', active: false }
        ]
      }else if(this.$getConstRole('ROLE_ADMIN') == this.getCurrentUser.role){
        sections = [
          { id: 1, name: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: 'dashboard', type: 'link', active: false },
          { id: 2, name: 'Clients', icon: 'mdi-account-group-outline', route: 'clients', type: 'link', active: false },
          { id: 3, name: 'Bookings', icon: 'mdi-file-document-multiple-outline', route: 'bookings', type: 'link', active: false },
          { id: 4, name: 'Containers', icon: 'mdi-cube-outline', route: 'containers', type: 'link', active: false },
          { id: 5, name: 'Invoices', icon: 'mdi-receipt-text-outline', route: 'invoices', type: 'link', active: false },
          { id: 6, name: 'Dispatch Orders', icon: 'mdi-truck-delivery-outline', route: 'delivery-orders', type: 'link', active: false },
          // { id: 5, name: 'Reports', icon: 'mdi-text-box-outline', route: 'reports', type: 'link', active: false },
          { id: 7, name: 'Rewards Club Royale', icon: 'mdi-medal-outline', route: 'rewards-clients', type: 'link', active: false },
          { id: 8, name: 'File Maintenance', icon: 'mdi-file-cog-outline', type: 'toggle', active: false,
            children: [
              { name: 'Overseas Warehouses', route: 'locations' },
              { name: 'Warehouses', route: 'warehouses' },
              { name: 'Users', route: 'users' }
            ]
          },
          { id: 9, name: 'Reports', icon: 'mdi-text-box-outline', type: 'toggle', active: false,
            children: [
              { name: 'Bookings', route: 'rpt-bookings' },
              { name: 'Sales', route: 'rpt-sales' },
              { name: 'CSR Sales', route: 'rpt-csr-sales' },
              { name: 'Dispatched', route: 'rpt-dispaching' },
              // { name: 'Users', route: 'rpt-users' },
            ]
          },
          { id: 10, name: 'Settings', icon: 'mdi-cog-outline', route: 'settings', type: 'link', active: false },
          { id: 11, name: 'Logout', icon: 'mdi-logout', route: 'logout', type: 'link', active: false }
        ]
      }else if(this.$getConstRole('ROLE_ACCOUNTING') == this.getCurrentUser.role){
        sections = [
          { id: 1, name: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: 'dashboard', type: 'link', active: false },
          { id: 3, name: 'Clients', icon: 'mdi-account-group-outline', route: 'clients', type: 'link', active: false },
          { id: 4, name: 'Invoices', icon: 'mdi-receipt-text-outline', route: 'invoices', type: 'link', active: false },
          { id: 5, name: 'Rewards Club Royale', icon: 'mdi-medal-outline', route: 'rewards-clients', type: 'link', active: false },
          { id: 6, name: 'Settings', icon: 'mdi-cog-outline', route: 'settings', type: 'link', active: false },
          { id: 7, name: 'Logout', icon: 'mdi-logout', route: 'logout', type: 'link', active: false }
        ]
      }else if(this.$getConstRole('ROLE_OPERATIONS') == this.getCurrentUser.role){
        sections = [
          { id: 1, name: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: 'dashboard', type: 'link', active: false },
          { id: 3, name: 'Clients', icon: 'mdi-account-group-outline', route: 'clients', type: 'link', active: false },
          { id: 4, name: 'Dispatch Orders', icon: 'mdi-truck-delivery-outline', route: 'delivery-orders', type: 'link', active: false },
          // { id: 5, name: 'Reports', icon: 'mdi-text-box-outline', route: 'reports', type: 'link', active: false },
          { id: 5, name: 'Settings', icon: 'mdi-cog-outline', route: 'settings', type: 'link', active: false },
          { id: 6, name: 'Logout', icon: 'mdi-logout', route: 'logout', type: 'link', active: false }
        ]
      }
      return sections
    }
  }
};
</script>
